<template>
    <v-container :key="prev">
        <dynamic-gradient-list />
    </v-container>
</template>

<script>
import DynamicGradientList from './UnlimitList/DynamicGradientList'

export default {
    components: {
        DynamicGradientList,
    },
    computed: {
        prev () {
            return this.$route.query.prev
        },
    },
}
</script>
